import { useMemo } from "react";
import { useSelector } from "react-redux";

const useLayer = (layerName) => {
  const layerService = useSelector((state) => {
    return state.map.layerService;
  });

  const layer = useMemo(() => {
    return layerService?.getLayer(layerName);
  }, [layerService, layerName]);

  return layer;
};

export default useLayer;
